// src/components/LoadingSpinner.js
//
// Suspense / route-loading fallback. A hand-drawn coral "locating" marker (the
// field-sheet city-marker language: a coral ring + center dot with a sweeping
// arc) instead of three bouncing dots — reads as "finding your way to care",
// warmer + on-system. The line art uses the global #ink-wobble filter for the
// hand-drawn tremble; reduced motion shows a static ring (LoadingSpinner.css).
import React from 'react';
import '../styles/LoadingSpinner.css';
import { T } from '../lib/gt-shim';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner-container">
      <svg
        className="loading-marker"
        viewBox="0 0 40 40"
        fill="none"
        aria-hidden="true"
        filter="url(#ink-wobble)">
        <circle className="loading-marker__track" cx="20" cy="20" r="14" />
        <circle className="loading-marker__sweep" cx="20" cy="20" r="14" />
        <circle className="loading-marker__dot" cx="20" cy="20" r="3" />
      </svg>
      {/* Pure-text child so it actually translates (the old mixed-JSX <T> was a
          no-op). */}
      <p className="loading-text">
        <T id="components.loadingspinner.0">Finding care…</T>
      </p>
    </div>
  );
};

export default LoadingSpinner;
